import React from 'react'
import { useTheme } from '@emotion/react'
import { FiltersContainer, StyledHeader } from './SearchFilters.styled'
import { TimeFilter } from '../../result-filters/TimeFilter/TimeFilter'
import { ResultSort } from '../../result-filters/ResultSort/ResultSort'
import { SectionHeader } from '../../section-header/SectionHeader/SectionHeader'
import {
    latestFirstSortOption,
    oldestFirstSortOption,
    relevanceSortOption,
} from '../../result-filters'
import { DataLayerEventName } from '@news-mono/web-common'
import {
    getArticleTopics,
    FilterEvent,
} from '../../result-filters/filter-events-util'
import { Filter } from '../../result-filters/Filter'

export type SearchFiltersProps = {
    showHeader: boolean
    onEvent: (event: FilterEvent) => void
}

export const SearchFilters = ({ showHeader, onEvent }: SearchFiltersProps) => {
    const theme = useTheme()
    const articleTopics = getArticleTopics(theme.kind)

    return (
        <FiltersContainer>
            {showHeader && (
                <StyledHeader>
                    <SectionHeader heading="Filter" />
                </StyledHeader>
            )}

            <TimeFilter
                onEvent={onEvent}
                dataLayerEventName={DataLayerEventName.searchFilter}
            />
            <ResultSort
                defaultOption={relevanceSortOption}
                options={[
                    relevanceSortOption,
                    latestFirstSortOption,
                    oldestFirstSortOption,
                ]}
                onEvent={onEvent}
                dataLayerEventName={DataLayerEventName.searchFilter}
            />
            <Filter
                headingText="Topic"
                queryFilterParam="topics"
                dataLayerEventOriginator="TopicFilter"
                filterItems={articleTopics}
                onEvent={onEvent}
                dataLayerEventName={DataLayerEventName.searchFilter}
            />
        </FiltersContainer>
    )
}
